export const URL_VALIDATION_ERROR = "Please enter a valid URL.";

export const normalizeUrl = (raw: string): string => {
  const input = raw?.trim() ?? "";
  if (!input) return "";
  return /^https?:\/\//i.test(input) ? input : `https://${input}`;
};

export const validateUrl = (
  raw: string
): { ok: true; value: string } | { ok: false; error: string } => {
  try {
    const input = (raw ?? "").trim();
    if (!input) return { ok: false, error: URL_VALIDATION_ERROR };

    const schemeMatch = input.match(/^([a-zA-Z][a-zA-Z0-9+.-]*):/);
    if (schemeMatch && !/^https?$/i.test(schemeMatch[1])) {
      return { ok: false, error: URL_VALIDATION_ERROR };
    }

    const candidate = normalizeUrl(input);
    const url = new URL(candidate);

    if (!["http:", "https:"].includes(url.protocol)) {
      return { ok: false, error: URL_VALIDATION_ERROR };
    }

    const host = url.hostname;
    if (
      !host ||
      host.startsWith(".") ||
      host.endsWith(".") ||
      !host.includes(".")
    ) {
      return { ok: false, error: URL_VALIDATION_ERROR };
    }

    if (
      (url.protocol === "http:" && url.port === "80") ||
      (url.protocol === "https:" && url.port === "443")
    ) {
      url.port = "";
    }
    url.username = "";
    url.password = "";

    return { ok: true, value: url.href };
  } catch {
    return { ok: false, error: URL_VALIDATION_ERROR };
  }
};

export const isValidUrl = (raw: string) => validateUrl(raw).ok;
